import { useCallback, useEffect } from 'react';
import { useFetcher } from 'react-router';

import { useActualBagSize } from '@jane/bloom/hooks/useBagSize';
import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import { CartAction } from '@jane/bloom/types/actions/cart';

export const useRefreshCart = () => {
  const basename = useBloomBasename();
  const fetcher = useFetcher();
  const bagSize = useActualBagSize();

  const fetchLatestCart = useCallback(() => {
    if (bagSize > 0) {
      fetcher.submit(
        {
          intent: CartAction.RefreshCart,
        },
        { action: `${basename}checkout`, method: 'post' }
      );
    }
  }, [basename, bagSize, fetcher]);

  useEffect(() => {
    document.addEventListener('visibilitychange', fetchLatestCart);
    window.addEventListener('focus', fetchLatestCart);

    return () => {
      document.removeEventListener('visibilitychange', fetchLatestCart);
      window.removeEventListener('focus', fetchLatestCart);
    };
  }, [fetchLatestCart]);
};
